import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import Papa from 'papaparse';
import { applyBrandedPdfChrome } from '../../branding/exportBranding';

const formatNumber = (value) => (Number.isFinite(value) ? value.toFixed(2) : '-');

export const exportStepTableToPDF = (rows) => {
    if (!rows.length) return;

    const doc = new jsPDF();
    doc.text('Step Frequency Table', 14, 15);
    doc.autoTable({
        head: [['Step Number', 'Total Frequency', 'Fail Count', 'Fail Percentage (%)', 'Average Fail Measure']],
        body: rows.map((item) => [
            `Step ${item.stepNumber}`,
            item.totalFrequency,
            item.failCount,
            item.failPercentage.toFixed(2),
            item.avgMeasureValue !== null ? formatNumber(item.avgMeasureValue) : '-',
        ]),
        startY: 20,
    });
    applyBrandedPdfChrome(doc, { title: 'Step Frequency Table' });
    doc.save('step_frequency_table.pdf');
};

export const exportStepTableToCSV = (rows) => {
    if (!rows.length) return;

    const csv = Papa.unparse(rows.map((item) => ({
        StepNumber: `Step ${item.stepNumber}`,
        TotalFrequency: item.totalFrequency,
        FailCount: item.failCount,
        FailPercentage: item.failPercentage.toFixed(2),
        AverageFailMeasure: item.avgMeasureValue !== null ? formatNumber(item.avgMeasureValue) : '-',
    })));

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'step_frequency_table.csv';
    link.click();
    URL.revokeObjectURL(link.href);
};
